import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

import type { CareersPageData } from "content-ui/utilityPages/careers/types";

import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchCareersPageData } from "content-ui/utilityPages/careers/fetcher";

import CareersView from "content-ui/utilityPages/careers";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import { SEO_SIFTED_ON_PINK_IMAGE } from "lib/constants/shared";

export async function getStaticProps({ preview = false }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchCareersPageData({ preview }),
  ]);

  return {
    props: {
      __initialState: {
        sitewideOption: { ...menuItems },
      },
      dato,
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PageProps = {
  dato: CareersPageData;
};

const CareersPage = (props: PageProps) => {
  const { seo } = props.dato.careerPage;
  const title = seo?.title || "Careers | Sifted";
  const description = seo?.description || "";
  const seoImage = seo?.image?.url || SEO_SIFTED_ON_PINK_IMAGE;

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/careers"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <CareersView data={props.dato.careerPage} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default CareersPage;
